var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilter = function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m0 4.376 7 8v8.567l6-2.25v-6.317l7-8V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v2.376ZM18 2v1H2V2h16ZM3.204 5h13.592l-5.25 6H8.454l-5.25-6ZM9 13v5.057l2-.75V13H9Z",
    fill: "currentColor"
  })));
};
export default SvgFilter;